import { alpha,  darken, lighten } from '@mui/material';
import { createTheme } from '@mui/material/styles';


const componentsOverrides = (theme) => {
    const oddRowColor = alpha(theme.palette.primary.main, 0.1);
    const evenRowColor = alpha(theme.palette.background.default, 0.8);
    const headerBackgroundColor = darken(theme.palette.primary.main, 0.2);

    return {

        MuiAutocomplete: {
            defaultProps: { fullWidth: true },
            styleOverrides: {
                inputRoot: { direction: 'rtl' },
                option: { direction: 'rtl', textAlign: 'right' },
                input: { direction: 'rtl', textAlign: 'right' },
            },
        },

        MuiInputBase: {
            styleOverrides: {
                input: {
                    textAlign: 'right',
                    direction: 'rtl',
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    direction: 'rtl',
                    '& legend': {
                        textAlign: 'right',
                        direction: 'rtl',
                    },
                },
                input: {
                    direction: 'rtl',
                    textAlign: 'right',
                },
                notchedOutline: {
                    textAlign: 'right',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    transformOrigin: 'top right',
                    left: 'unset',
                    right: '2.5rem',  // add slight right offset if necessary
                    direction: 'rtl',
                    '&.Mui-focused': {
                        transformOrigin: 'top right',
                    },
                        // Specifically when used within Autocomplete
            '.MuiAutocomplete-root &': {
                right: '4.5rem',  // add slight right offset if necessary
            },
                },
                
                outlined: {
                    '&.MuiInputLabel-shrink': {
                        transform: 'translate(20px, -9px) scale(0.75)', // explicitly adjust this value
                         '.MuiAutocomplete-root &': {
                    transform: 'translate(55px, -9px) scale(0.75)', // Adjust Autocomplete shrink position
                },
                        
                    },
                    
                },
            },
        },
        MuiSelect2: {
            styleOverrides: {
                select: {
                    textAlign: 'right',
                    direction: 'rtl',
                },
                icon: {
                    right: 'unset',
                    left: '7px', // Adjust slightly if needed
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                InputProps: {
                    style: { direction: 'rtl' },
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    direction: 'ltr', // Ensures icon itself doesn't flip
                },
            },
        },
 
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    direction: 'rtl',
                },
                inputRoot: {
                    paddingRight: '8px !important',
                    paddingLeft: '39px !important', // Adjust padding for icon space
                    direction: 'rtl',
                },
                endAdornment: {
                    right: 'unset !important',
                    left: '9px !important', // Move dropdown icon clearly to the left
                },
                option: {
                    textAlign: 'right',
                    direction: 'rtl',
                },
                popupIndicator: {
                    transform: 'rotate(180deg)', // Optional if needed to flip the icon direction
                },
            },
        },
        

        

        MuiAppBar: {
            styleOverrides: {
                colorSecondary: {
                    background: `linear-gradient(20deg, ${theme.palette.primary.main} 30%, ${lighten(theme.palette.primary.main, 0.3)} 90%)`,
                    color: theme.palette.text.contrastText,
                },
            },
        },
        MuiAutocomplete: {
            defaultProps: {
                fullWidth: true,
            },
        },
        MuiButton: {
            defaultProps: {
                variant: 'outlined',
            },
            styleOverrides: {
                sizeSmall: {
                    padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
                },
            },
        },
        MuiFormControl: {
            defaultProps: {
                variant: 'outlined',
                margin: 'dense',
                size: 'small',
                fullWidth: true,
            },
        },
        MuiPaper: {
            styleOverrides: {
                elevation1: {
                    boxShadow: `${alpha(theme.palette.primary.main, 0.2)} -2px 2px, ${alpha(theme.palette.primary.main, 0.1)} -4px 4px, ${alpha(theme.palette.primary.main, 0.05)} -6px 6px`,
                },
                root: {
                    backgroundClip: 'padding-box',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(1),
                    '&.MuiTableCell-sizeSmall': {
                        padding: theme.spacing(1),
                    },
                    '&.MuiTableCell-paddingNone': {
                        padding: 0,
                    },
                    textAlign: 'right', // Align text to the right for RTL
                },
                head: {
                    backgroundColor: headerBackgroundColor,
                    color: theme.palette.primary.contrastText,
                    fontWeight: theme.typography.fontWeightBold,
                    textAlign: 'right', // Align header text to the right for RTL
                    borderBottom: `2px solid ${theme.palette.divider}`,
                    '&:first-of-type': {
                        borderTopRightRadius: theme.shape.borderRadius,
                        borderTopLeftRadius: 0,
                    },
                    '&:last-of-type': {
                        borderTopLeftRadius: theme.shape.borderRadius,
                        borderTopRightRadius: 0,
                    },
                },
            },
        },
        MuiTableSortLabel: {
            styleOverrides: {
                root: {
                    color: `${theme.palette.primary.contrastText} !important`,
                    '&.Mui-active': {
                        color: `${theme.palette.primary.contrastText} !important`,
                    },
                    '&:hover': {
                        color: `${theme.palette.primary.contrastText} !important`,
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: `${theme.palette.primary.contrastText} !important`,
                    },
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&:nth-of-type(odd)': {
                        backgroundColor: oddRowColor,
                    },
                    '&:nth-of-type(even)': {
                        backgroundColor: evenRowColor,
                    },
                    '&:last-child td': { border: 0 },
                },
            },
        },
        RaDatagrid: {
            styleOverrides: {
                root: {
                    '& .RaDatagrid-headerCell': {
                        color: theme.palette.primary.contrastText,
                        backgroundColor: headerBackgroundColor,
                        fontWeight: theme.typography.fontWeightBold,
                        textAlign: 'right', // Ensure header cells are aligned to the right
                        '&:first-of-type': {
                            borderTopRightRadius: theme.shape.borderRadius,
                            borderTopLeftRadius: 0,
                        },
                        '&:last-of-type': {
                            borderTopLeftRadius: theme.shape.borderRadius,
                            borderTopRightRadius: 0,
                        },
                    },
                    '& .RaDatagrid-cell': {
                        textAlign: 'right', // Ensure cells are aligned to the right for RTL
                    },
                },
                direction: 'rtl', // Set the entire Datagrid to RTL
            },
        },
        RaSimpleFormIterator: {
            defaultProps: {
                fullWidth: true,
            },
        },
        RaTranslatableInputs: {
            defaultProps: {
                fullWidth: true,
            },
        },
    };
};

const alert = {
    error: { main: '#DB488B' },
    warning: { main: '#F2E963' },
    info: { main: '#3ED0EB' },
    success: { main: '#0FBF9F' },
};

const darkPalette = {
    primary: { main: '#9055fd' },
    secondary: { main: '#FF83F6' },
    background: { default: '#110e1c', paper: '#151221' },
    ...alert,
    mode: 'dark',
};

const lightPalette2 = {
    mode: 'light',
    primary: { main: '#002855' },
    secondary: { main: '#e1523e' },
    background: { default: '#f9fafb' },
    text: { primary: '#212b36' },
}

const lightPalette = {
    primary: {
        main: '#4f3cc9',
        contrastText: '#fff',
    },
    secondary: {
        light: '#5f5fc4',
        main: '#283593',
        dark: '#001064',
        contrastText: '#fff',
    },
    background: {
        default: '#fcfcfe',
    },

    ...alert,
    mode: 'light',
};

const createRadiantTheme = (palette) => {
    const themeOptions = {
        direction: "rtl",
        palette,
        shape: { borderRadius: 6 },
        sidebar: { width: 200 },
        spacing: 8,
        typography: {
            fontFamily: 'Almarai, tahoma, sans-serif',
            h1: {
                fontWeight: 500,
                fontSize: '6rem',
            },
            h2: { fontWeight: 600 },
            h3: { fontWeight: 700 },
            h4: { fontWeight: 800 },
            h5: { fontWeight: 900 },
            button: { textTransform: undefined, fontWeight: 700 },
        },
    };
    const theme = createTheme(themeOptions);
    theme.components = componentsOverrides(theme);
    return theme;
};

export const radiantLightTheme = createRadiantTheme(lightPalette2);
export const radiantDarkTheme = createRadiantTheme(lightPalette2);
